<template>
  <div>
    <div class="big-title">
      <span>地区及机构</span>
    </div>
    <a-row>
        <a-row :gutter="4">
          <a-col :span="3">
            <span class="list-header">抽检市级</span>
          </a-col>
          <a-col :span="15">
            <span class="list-header">抽检区县级选择</span>
          </a-col>
          <a-col :span="2">
            <span class="list-header">总数</span>
          </a-col>
          <a-col :span="4">
            <span class="list-header">检测机构</span>
          </a-col>
        </a-row>
        <a-row v-for="task in localValue" v-if="(!disabled)||task.execDept" :gutter="4" :style="{margin:'4px'}">
          <a-col>
            <a-row v-if="(!disabled)||task.execDept">
              <a-col :span="3">
                <div class="box">{{task.regionName}}</div>
              </a-col>
              <a-col :span="15">
                <div class="box" style="text-align: left;line-height: 30px;">
                  <a-row>
                    <a-col span="22">
                      <a-tag v-for="(monitTaskRegion,index) in task.monitTaskRegionList" style="vertical-align: super"  :key="index">
                        <template v-if="!disabled">
                          {{monitTaskRegion.regionName+'-'+monitTaskRegion.pickCount}}
                          <span  style="cursor: pointer;font-size: 14px"  @click="removemonitTaskRegionList(task,monitTaskRegion)">×</span>
                        </template>
                        <template v-else>
                          {{monitTaskRegion.regionName+'('+monitTaskRegion.pickCount+')'}}
                        </template>
                      </a-tag>
                      <div style="display: inline-block;height: 30px;width: 1px"></div>
                    </a-col>
                    <a-col span="2">
                      <a-icon v-if="!disabled" type="plus-circle" theme="twoTone" @click="addmonitTaskRegionList(task)" />
                    </a-col>

                  </a-row>
                </div>
              </a-col>
              <a-col :span="2">
                <div class="box">
                  {{task.total}}
                </div>
              </a-col>
              <a-col :span="4">
                <a-ext-gov-select :disabled="disabled" v-model="task.execDept"></a-ext-gov-select>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
        <a-row :gutter="4" :style="{margin:'4px'}">
          <a-col :span="18">
          </a-col>
          <a-col :span="2">
            <div v-if="!disabled" class="total-box">
              总数量：<span style="color: red">{{total}}</span>
            </div>
          </a-col>
          <a-col :span="4">
          </a-col>
        </a-row>
    </a-row>
    <check-target-picker-modal  v-if="modalVisable" :visible.sync="modalVisable"
                                :param="modalParam"
                                @dialogBack="onModalClose"></check-target-picker-modal>
  </div>
</template>

<script>
import mixin from '../mixin/AExtArrayMixin'
import CheckTargetPickerModal from './CheckTargetPickerModal'
import AExtGovSelect from './AExtGovSelect'


export default {
    components:{AExtGovSelect,CheckTargetPickerModal},
    name: "index",
    mixins:[mixin],
    props:{
        //sync修饰
      total:{
          type:Number,
          default:0
      },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            options:[],
            localValue: [],
            modalVisable: false,
            modalBackChange: null,
            modalParam: null
        }
    },
    created(){
      this.init()
    },
    methods:{
        init(){
            let total=this.getMonitTargetCountAll(this.localValue);
            this.total=total

            this.$emit('update:total', total)
        },
        addmonitTaskRegionList(task)
        {
            //需要弹窗
            this.modalParam={regionCode:task.regionCode};
            this.modalBackChange=task;
            this.modalVisable=true;
        },
        removemonitTaskRegionList(task,monitTaskRegion)
        {
            task.total-=monitTaskRegion.pickCount;
            task.monitTaskRegionList.remove(monitTaskRegion);
            let totalRow = this.getMonitTargetCount(task.monitTaskRegionList);
            task.total=totalRow;
            let total=this.getMonitTargetCountAll(this.localValue);
            this.total=total;
            this.$emit('update:total', total )
        },
        getMonitTargetCount(arr)
        {
            if (arr)
            {
                let i=0;
                arr.forEach(item=>{
                    i+=item.pickCount;
                })
                return i;
            }
            else {
                return 0;
            }
        },
        getMonitTargetCountAll(array)
        {
            let i=0;
            array.forEach(item=>{
                let arr=item.monitTaskRegionList;
                if (arr)
                {
                    arr.forEach(item=>{
                        i+=item.pickCount;
                    });

                }
            });
            return i;
        },
        onModalClose(result){
            let task=this.modalBackChange;
            let detail={regionName: result.regionName,regionCode: result.regionCode, pickCount:result.pickCount};
            task.monitTaskRegionList.push(detail);
            let totalRow = this.getMonitTargetCount(task.monitTaskRegionList);
            task.total=totalRow;
            let total=this.getMonitTargetCountAll(this.localValue);
            this.total=total

            this.$emit('update:total', total)
        }
    }

}
</script>

<style scoped>
  .box{
    display: block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-top-width: 1.02px;
    border-radius: 4px;
    outline: none;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    text-align: center;
    padding-left: 5px;
    font-weight: 700;
    color: #7c7c7c;
    margin-right: 5px;
  }

  .total-box{
    font-weight: 700;
    color: #7c7c7c;
  }

  /deep/ .ant-select-selection--single{
    height: 40px;
  }

  /deep/ .ant-select{
    vertical-align: top;
  }

  /deep/ .ant-select-selection__rendered{
    line-height: 40px;
    color: #7c7c7c;
    font-weight: 700;
  }
  .list-header {
    padding-left: 20px;
    color: #888888;
    font-weight: 700;
  }

  .big-title {
    color: #444444;
    font-weight: 700;
  }
</style>